import { Component, Input, output } from '@angular/core';

import type { OfferFull } from '@core/offers-types';
import { OffersPageGroupHeadingComponent } from '@core/offers-ui';
import type { LayoutListHeaderComponent } from '@recruitee/views-util';

@Component({
  selector: 'rt-offer-card-heading',
  imports: [OffersPageGroupHeadingComponent],
  template: `<rt-offers-page-group-heading
    [state]="isCollapsed ? 'collapsed' : 'normal'"
    [name]="recordData.group!.label"
    [counter]="recordData.data?.meta?.totalCount ?? 0"
    (click)="click.emit(recordData)"
  />`,
})
export class OfferListHeadingComponent implements LayoutListHeaderComponent<OfferFull> {
  @Input() public recordData: LayoutListHeaderComponent<OfferFull>['recordData'];
  @Input() public isCollapsed: boolean = false;

  public click = output<this['recordData']>();
}
